import { Modal, ModalBody, modalConnect } from "@modal";
import { ceModalInsertCustomFieldClose } from "@js/actions/studio/campaign_content_section/modal_insert_custom_field.js";
import classNames from "@js/helpers/class_names.js";

const ModalInsertCustomFields = modalConnect((props) => {
  const Field = (p) => {
    let select = (e) => {
      e.preventDefault();
      props.dispatch(ceModalInsertCustomFieldClose());
      props.connector.trigger({ type: "insert", value: `%%${p.code}%%` });
    };

    return (
      <a
        onClick={select}
        key={p.key}
        href="#"
        className={classNames({
          "insert-custom-field": true,
          button: true,
          "diminished-button": p.is_custom_field,
        })}
      >
        {p.label}
      </a>
    );
  };

  return (
    <Modal
      title={t("buttons.insert_field")}
      onCancel={() => props.dispatch(ceModalInsertCustomFieldClose())}
    >
      <ModalBody>
        <div className="custom-field-selector">
          <div className="custom-fields-for-1 custom-fields-for-mailing-list">
            <div className="custom-field-name-cloud">
              {props.available_fields.map((field) => (
                <Field key={field.code} {...field} />
              ))}
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
});

export default ModalInsertCustomFields;
